import { UserOutlined } from '@ant-design/icons'
import { Avatar, AvatarProps } from 'antd'
import { useAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { departmentsMapAtom } from '@/modules/department'
import { usersMapAtom } from '@/modules/user'

import { MosaicComponent } from './permission.component'

interface UserNameProps {
  email?: string
  avatar?: boolean
  maxWidth?: number
}

export const UserName: React.FC<UserNameProps> = ({ email, maxWidth }) => {
  const [usersMap] = useAtom(usersMapAtom)
  if (!email) {
    return null
  }
  const user = usersMap[email]
  const name = user ? user.name : email.split('@')[0]
  return (
    <span
      style={{ maxWidth }}
      className={maxWidth ? 'block whitespace-nowrap overflow-hidden overflow-ellipsis' : undefined}
    >
      {name}
    </span>
  )
}

interface UserAvatarProps {
  email?: string
  showName?: boolean
  maxWidth?: number
}

export const UserAvatar: React.FC<UserAvatarProps & AvatarProps> = ({ email, showName, maxWidth, ...props }) => {
  const [usersMap] = useAtom(usersMapAtom)
  if (!email) {
    return null
  }
  const user = usersMap[email]
  return (
    <span className='cursor-default flex items-center' enterprise-user-card={email}>
      <Avatar className='flex-shrink-0' src={user?.avatar} {...props} icon={<UserOutlined />} />
      {showName && (
        <span className='ml-8px'>
          <UserName email={email} maxWidth={maxWidth} />
        </span>
      )}
    </span>
  )
}

export const DepartmentName: React.FC<{ departmentId?: number; canRead: boolean }> = ({ departmentId, canRead }) => {
  if (!canRead) return <MosaicComponent />
  if (!departmentId) return null
  const [departmentsMap] = useAtom(departmentsMapAtom)
  const { i18n } = useTranslation()
  return departmentId in departmentsMap
    ? i18n.resolvedLanguage === 'zh'
      ? departmentsMap[departmentId].name
      : departmentsMap[departmentId].ename
    : (null as any)
}
